/* eslint-disable @typescript-eslint/no-explicit-any */
import newColorAxiosInstance from "@/common-components-src/api/new-color-axiosInstance";
import {
  ICancelOrderRes,
  ICancelOrderReq,
  IOrderListReq,
  IOrderListRes,
  IOrderDetailReq,
  IOrderDetailRes,
  ICancelReasonListRes,
  ILogisticsListRes,
  IDelHistoryOrderRes,
  RefundDetailInfoDTO,
  InvoiceListDTO,
  PreCancelDTO,
} from "./order.interface";

interface Data {
  data: IOrderListRes;
}

interface DetailData {
  data: IOrderDetailRes;
}

interface CancelReasonListData {
  data: ICancelReasonListRes;
}

interface LogisticsListData {
  data: ILogisticsListRes;
}

interface DelHistoryOrderData {
  data: IDelHistoryOrderRes;
}

interface CancelOrdeData {
  data: ICancelOrderRes;
}

interface RefundDetailInfoData {
  data: RefundDetailInfoDTO;
}

interface InvoiceListData {
  data: InvoiceListDTO;
}

interface preCancelRes {
  data: PreCancelDTO;
}

// 查询订单列表的 API 方法
export const fetchOrderList = (requestData: IOrderListReq): Promise<IOrderListRes> => {
  return newColorAxiosInstance
    .get<Data>("trade_order_getList", {
      params: {
        size: "10",
        ...requestData,
      },
    })
    .then((response: any) => response.data.data);
};

// 查询订单详情的 API 方法
export const fetchOrderDetail = (requestData: IOrderDetailReq): Promise<IOrderDetailRes> => {
  return newColorAxiosInstance
    .get<DetailData>("trade_order_get", {
      params: { ...requestData },
    })
    .then((response: any) => response.data.data);
};

// 查询取消原因列表的 API 方法
export const fetchCancelReasonList = (requestData: IOrderDetailReq): Promise<ICancelReasonListRes> => {
  return newColorAxiosInstance
    .get<CancelReasonListData>("trade_order_getCancelReasons", {
      params: { ...requestData },
    })
    .then((response: any) => response.data.data);
};

// 删除历史订单的 API 方法
export const delHistoryOrder = (requestData: IOrderDetailReq): Promise<IDelHistoryOrderRes> => {
  return newColorAxiosInstance
    .get<DelHistoryOrderData>("trade_order_deleteOrder", {
      params: { ...requestData },
    })
    .then((response: any) => response.data.data);
};

// 取消订单的 API 方法
export const cancelOrder = (requestData: ICancelOrderReq): Promise<ICancelOrderRes> => {
  return newColorAxiosInstance
    .get<CancelOrdeData>("trade_order_cancel", {
      params: { ...requestData },
    })
    .then((response: any) => response.data.data);
};

// 查询物流信息列表的 API 方法
export const fetchLogisticsList = (requestData: IOrderDetailReq): Promise<ILogisticsListRes> => {
  return newColorAxiosInstance
    .get<LogisticsListData>("trade_order_getTrace", {
      params: { ...requestData },
    })
    .then((response: any) => response.data.data);
};

// 退款详情
export const orderCancelRefund = (requestData: IOrderDetailReq): Promise<RefundDetailInfoDTO> => {
  return newColorAxiosInstance
    .get<RefundDetailInfoData>("trade_order_getOrderRefundInfo", {
      params: { ...requestData },
    })
    .then((response: any) => response.data.data);
};

// 查询订单发票列表的 API 方法
export const fetchInvoiceList = (requestData: IOrderDetailReq): Promise<InvoiceListDTO> => {
  return newColorAxiosInstance
    .get<InvoiceListData>("trade_order_getInvoiceList", {
      params: { ...requestData },
    })
    .then((response: any) => response.data.data);
};

// 订单预取消
export const preCancelOrder = (requestData: IOrderDetailReq): Promise<PreCancelDTO> => {
  return newColorAxiosInstance
    .get<preCancelRes>("trade_order_preCancel", {
      params: { ...requestData },
    })
    .then((response: any) => response.data.data);
};
